/**
 All of the routes for the Spk UI Dashboard React are added here,
 You can add a new route, customize the routes and delete the routes here.
 Once you add a new route on this file it will be visible automatically on
 the Sidenav.
 For adding a new route you can follow the existing routes in the routes array.
 2. The `type` key with the `title` value is used for a title inside the Sidenav.
 3. The `type` key with the `divider` value is used for a divider between Sidenav items.
 4. The `name` key is used for the name of the route on the Sidenav.
 5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
 6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
 8. The `route` key is used to store the route location which is used for the react router.
 9. The `href` key is used to store the external links location.
 10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
 10. The `component` key is used to store the component of its route.
 */

import {
    _404Page,
    Activity_Recom_FormPage,
    CS_AddEdit_FormPage,
    CS_InternalPage,
    CS_Recom_FormPage,
    DashboardPage,
    Doc_AddEdit_FormPage,
    Doc_InternalPage,
    Doc_Recom_FormPage,
    ForgotPwPage,
    Forum_AddEdit_Page,
    Forum_InternalPage,
    ForumPage,
    HelpPage,
    Image_AddEdit_FormPage,
    Image_Recom_FormPage,
    LegalNoticePage,
    Link_AddEdit_FormPage,
    Link_InternalPage,
    Link_Recom_FormPage,
    LoginPage,
    Meeting_AddEdit_Page,
    Meeting_InternalPage,
    MeetingsPage,
    Message_Internal_Page,
    MessagePage,
    MyParticipationsPage,
    News_Recom_FormPage,
    Peer_Recom_FormPage,
    PeerProfile_Internal_Page,
    PeerProfilesPage,
    Pub_AddEdit_FormPage,
    Pub_InternalPage,
    Pub_Recom_FormPage,
    RequestAccessPage,
    Res_Recom_FormPage,
    ResourcesPage,
    SearchPage,
    Survey_AddEdit_Page,
    Survey_AddEditQsPage,
    Survey_InternalPage,
    Survey_ViewPage,
    Survey_ViewQsPage,
    SurveyPage,
    TermsOfUsePage,
    TestPage,
    UserProfilePage,
    Video_AddEdit_FormPage,
    Video_Recom_FormPage,
    WebMeetingPage,
    Wm_AddEdit_Page,
    Wm_InternalPage,
} from "./index";
import {GenRouteUrls, ModuleRouteUrls, Modules} from "./config/AppConfig";
import {getDefStr, isBoolTrue} from "../common/fusion-ui/utils/ReactUtils";
import {useAuth} from "./context/AuthProvider";
import {isCurrUserRoleAdmin, isModuleAllocated} from "./utils/AppUtils";

const TAG = 'routes.js';

export default function getAppRoutes(isCurrUrlOfAuthRoute = false) {
    const {isAuthenticated} = useAuth();
    // console.log(TAG, 'getAppRoutes.isAuthenticated:', isAuthenticated);

    return isAuthenticated ? getPrivateRoutes() : getPublicRoutes();

    // return getPublicRoutes();

    function getPublicRoutes() {
        return [
            // createRoute(Modules.Home, <LoginPage/>),
            createRoute(Modules.Login, <LoginPage/>, false, GenRouteUrls.login),
            createRoute(Modules.RequestAccess, <RequestAccessPage/>, false, GenRouteUrls.requestAccess),
            createRoute(Modules.ForgotPw, <ForgotPwPage/>, false, GenRouteUrls.forgotPw),
        ]
    }

    function getPrivateRoutes() {
        return [
            //Pages
            createRoute(Modules.Home, <DashboardPage/>),
            createRoute(Modules.Dashboard, <DashboardPage/>),
            createRoute(Modules.UserProfile, <UserProfilePage/>),

            //Allocation-based routes
            createRoute(Modules.WebMeeting, <WebMeetingPage/>, true),
            createRoute(Modules.DiscussionForum, <ForumPage/>, true),
            createRoute(Modules.Survey, <SurveyPage/>, true),
            createRoute(Modules.Resources, <ResourcesPage/>, true),
            createRoute(Modules.PeerProfiles, <PeerProfilesPage/>, true),
            createRoute(Modules.Messages, <MessagePage/>, true),
            createRoute(Modules.Meetings, <MeetingsPage/>, true),
            createRoute(Modules.MyParticipations, <MyParticipationsPage/>, true),
            createRoute(Modules.Search, <SearchPage/>, true),

            //Home-tabs
            createRoute(Modules.RecentResources, <DashboardPage tabLayoutDefTab={Modules.RecentResources}/>, true),
            createRoute(Modules.Publication, <DashboardPage tabLayoutDefTab={Modules.Publication}/>, true),
            createRoute(Modules.Documents, <DashboardPage tabLayoutDefTab={Modules.Documents}/>, true),
            createRoute(Modules.CaseStudy, <DashboardPage tabLayoutDefTab={Modules.CaseStudy}/>, true),
            createRoute(Modules.Videos, <DashboardPage tabLayoutDefTab={Modules.Videos}/>, true),
            createRoute(Modules.Images, <DashboardPage tabLayoutDefTab={Modules.Images}/>, true),
            createRoute(Modules.UsefulLinks, <DashboardPage tabLayoutDefTab={Modules.UsefulLinks}/>, true),

            //Other
            createRoute(Modules.Legal, <LegalNoticePage/>),
            createRoute(Modules.Help, <HelpPage/>),
            createRoute(Modules.TermsOfUse, <TermsOfUsePage/>),

            //Internal pages
            createInternalPageRoute(Modules.Publication, <Pub_InternalPage/>, GenRouteUrls.pub_internalPage, true),
            createInternalPageRoute(Modules.WebMeeting, <Wm_InternalPage/>, GenRouteUrls.wm_internalPage, true),
            createInternalPageRoute(Modules.DiscussionForum, <Forum_InternalPage/>, GenRouteUrls.df_internalPage, true),
            createInternalPageRoute(Modules.Survey, <Survey_InternalPage/>, GenRouteUrls.survey_internalPage, true),
            createInternalPageRoute(Modules.Survey, <Survey_ViewPage/>, GenRouteUrls.survey_viewSurveyPage, true),
            createInternalPageRoute(Modules.Survey, <Survey_ViewQsPage/>, GenRouteUrls.survey_viewQsPage, true),
            createInternalPageRoute(Modules.Meetings, <Meeting_InternalPage/>, GenRouteUrls.meeting_internalPage, true),
            createInternalPageRoute(Modules.CaseStudy, <CS_InternalPage/>, GenRouteUrls.cs_internalPage, true),
            createInternalPageRoute(Modules.UsefulLinks, <Link_InternalPage/>, GenRouteUrls.link_internalPage, true),
            createInternalPageRoute(Modules.Documents, <Doc_InternalPage/>, GenRouteUrls.doc_internalPage, true),
            createInternalPageRoute(Modules.PeerProfiles, <PeerProfile_Internal_Page/>, GenRouteUrls.pp_internalPage, true),
            createInternalPageRoute(Modules.Messages, <Message_Internal_Page/>, GenRouteUrls.msg_internalPage, true),

            //Form pages (only for admins)
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Meetings, <Meeting_AddEdit_Page/>, GenRouteUrls.meeting_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Meetings, <Meeting_AddEdit_Page updateOnly={true}/>, GenRouteUrls.meeting_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.WebMeeting, <Wm_AddEdit_Page/>, GenRouteUrls.wm_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.WebMeeting, <Wm_AddEdit_Page updateOnly={true}/>, GenRouteUrls.wm_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.DiscussionForum, <Forum_AddEdit_Page/>, GenRouteUrls.df_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.DiscussionForum, <Forum_AddEdit_Page updateOnly={true}/>, GenRouteUrls.df_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Survey, <Survey_AddEdit_Page/>, GenRouteUrls.survey_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Survey, <Survey_AddEdit_Page updateOnly={true}/>, GenRouteUrls.survey_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Publication, <Pub_AddEdit_FormPage/>, GenRouteUrls.pub_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Publication, <Pub_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.pub_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Videos, <Video_AddEdit_FormPage/>, GenRouteUrls.vid_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Videos, <Video_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.vid_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Images, <Image_AddEdit_FormPage/>, GenRouteUrls.img_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Images, <Image_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.img_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Documents, <Doc_AddEdit_FormPage/>, GenRouteUrls.doc_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Documents, <Doc_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.doc_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.CaseStudy, <CS_AddEdit_FormPage/>, GenRouteUrls.cs_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.CaseStudy, <CS_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.cs_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.UsefulLinks, <Link_AddEdit_FormPage/>, GenRouteUrls.link_uploadPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.UsefulLinks, <Link_AddEdit_FormPage updateOnly={true}/>, GenRouteUrls.link_editPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Survey, <Survey_AddEditQsPage updateOnly={false}/>, GenRouteUrls.survey_createQsPage),
            isCurrUserRoleAdmin() && createInternalPageRoute(Modules.Survey, <Survey_AddEditQsPage updateOnly={true}/>, GenRouteUrls.survey_editQsPage),

            //Recom-Form pages
            createInternalPageRoute(Modules.Publication, <Pub_Recom_FormPage/>, GenRouteUrls.pub_recomPage, true),
            createInternalPageRoute(Modules.Videos, <Video_Recom_FormPage/>, GenRouteUrls.vid_recomPage, true),
            createInternalPageRoute(Modules.Documents, <Doc_Recom_FormPage/>, GenRouteUrls.doc_recomPage, true),
            createInternalPageRoute(Modules.CaseStudy, <CS_Recom_FormPage/>, GenRouteUrls.cs_recomPage, true),
            createInternalPageRoute(Modules.UsefulLinks, <Link_Recom_FormPage/>, GenRouteUrls.link_recomPage, true),
            createInternalPageRoute(Modules.Images, <Image_Recom_FormPage/>, GenRouteUrls.img_recomPage, true),
            createInternalPageRoute(Modules.Resources, <Res_Recom_FormPage/>, GenRouteUrls.res_recomPage, true),
            createInternalPageRoute(Modules.RecommendPeer, <Peer_Recom_FormPage/>, GenRouteUrls.recom_PeerPage, true),
            createInternalPageRoute(Modules.RecommendActivity, <Activity_Recom_FormPage/>, GenRouteUrls.recom_activity, true),
            createInternalPageRoute(Modules.News, <News_Recom_FormPage/>, GenRouteUrls.news_recommendNewsForm, true),

            //Include 404 route as default-route
            !isBoolTrue(isCurrUrlOfAuthRoute) && {route: GenRouteUrls._404, component: <_404Page/>},

            createRoute(Modules.Test, <TestPage/>),
            // {
            //     type: "route",
            //     name: "Dashboard",
            //     key: "dashboard",
            //     route: "/dashboard",
            //     icon: <AppBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2"/>,
            //     component: <DashboardPage/>,
            // },
        ]
    }
}

function createRoute(moduleName, component, allocBased = false, routeUrl = null) {
    return (!isBoolTrue(allocBased) || (isBoolTrue(allocBased) && isModuleAllocated(moduleName))) && {
        route: getDefStr(routeUrl, ModuleRouteUrls[moduleName]),
        component: component,
    }
}

function createInternalPageRoute(moduleName, component, routeUrl, allocBased = false) {
    return (!isBoolTrue(allocBased) || (isBoolTrue(allocBased) && isModuleAllocated(moduleName))) && {
        // route: (routeUrl + '').replace('?id=', ''),
        route: (routeUrl + '').replace('?id=', '').replace('?sid=', ''),
        component: component,
    }
}
